import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { ILogsUserData } from '@pharmaplan/common';

import { performerTypeMapper } from '../../../../helpers/Constants';
import DisplayChip from '../../../common/DisplayChip';

import styles from './styles';

interface IActivityLogUserItem {
  user: ILogsUserData;
}

const ActivityLogUserItem: FC<IActivityLogUserItem> = ({ user }) => {
  const { userName, email, userType } = user ?? {};

  return (
    <Box sx={styles.item}>
      <Box sx={styles.header}>
        <Typography sx={styles.name}>{userName}</Typography>
        <DisplayChip
          value={performerTypeMapper[userType]}
          style={styles.userTypeChip}
        />
      </Box>
      <Typography sx={styles.email}>{email}</Typography>
    </Box>
  );
};

export default ActivityLogUserItem;
